
(function (window, document, jQuery) {
    var $ = jQuery.noConflict();     
    var $html = $('html');
    var $body = $('body');
    var $btn = $("#NavbarSearchButton");    
    var $searchInput = $("#NavbarSearchString");

    $searchInput.on('focus', function () { $(this).select(); })

    // change placeholder text
    if ($html.attr('lang', 'de-de')) {
        $searchInput.attr('placeholder', 'Suche');
    }

    // what should happen on search icon click...
    $btn.click(function (e) {
        // wait until search is popped up and then focus        
        var maxTicks = 2000; // 2s
        var ticksCount = 0;
        var ticks = 100; // 100ms
        var interval = setInterval(
            function CheckVisibility() {
                if ($searchInput.is(":visible")) {
                    // is visible, do something and reset interval
                    $searchInput.focus();                    
                    ticksCount = 0;
                    clearInterval(interval);
                } else {
                    // is still not found, try again or cancel if max is reached
                    ticksCount += ticks;
                    if (ticksCount > maxTicks) {
                        ticksCount = 0;
                        clearInterval(interval);
                    }
                }
            },
            ticks);        
    });

    // change mainNavLinks to be links instead toggel dropdown buttons
    function transformMainNavLink() {
        // get links; skip if no links found
        var $mainNavLinks = $('.kit-navbar__item--level-2.dropdown-toggle');
        if (!$mainNavLinks.length) {
            return
        }

        // if lg+ transform links
        if ($body.hasClass('is-lg')) {
            $mainNavLinks.each(function () {
                var $link = $(this);
                $link.on('touchstart click', function (e) {
                    if ($link.length > 0) {
                        window.location.href = $link[0].href;
                    }
                });          
            });
        }
        else {
            $mainNavLinks.dropdown();
            $mainNavLinks.each(function () {
                var $link = $(this);

                $link.parent().click(
                    function () {
                        $link.dropdown('show');
                    },
                    function () {
                        $link.dropdown('hide');
                    }
                );                
            });
        }
    }

    // wait until finished resizing, than do actions
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            transformMainNavLink();
        }, 200);
    });

    // actions on load
    $(document).ready(function () {
        transformMainNavLink();
    });

})(window, document, jQuery);
